const showProgressAlert = () => {
    const alertWidget = document.getElementById('page_circle_progress');
    alertWidget.style.display = 'flex';
}
const HideProgressAlert = () => {
    const alertWidget = document.getElementById('page_circle_progress');
    alertWidget.style.display = 'none';
}
export { showProgressAlert, HideProgressAlert };